import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/SuscriptionPremium.png'


const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "¿Quieres seguir utilizando nuestro contenido?", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "Apuntate a nuestro plan de suscripciones!", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "premiumSubscription",
  src: _imports_0,
  alt: "premiumSubscription"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return ($setup.isModalOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args))),
              class: "close-button"
            }, "X")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _createVNode(_component_router_link, { to: "/subscription" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}